import { render, staticRenderFns } from "./CeldaTexto.vue?vue&type=template&id=c2ac3874&scoped=true&"
import script from "./CeldaTexto.vue?vue&type=script&lang=js&"
export * from "./CeldaTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ac3874",
  null
  
)

export default component.exports